export type AppConfig = ReturnType<typeof getAppConfig>;

export const getAppConfig = () => ({
  apiBaseUrl:
    "https://sbv-expertsystem-bot-prod.yellowpebble-5535600a.switzerlandnorth.azurecontainerapps.io",
  chainlitServerUrl:
    "https://sbv-expertsystem-bot-prod.yellowpebble-5535600a.switzerlandnorth.azurecontainerapps.io/chatbot",
  datatransSandboxUrl: "https://pay.datatrans.com/v1/start",
  b2cPolicies: {
    signin: "B2C_1_SIGNIN_PROD",
    signup: "B2C_1A_SIGNUP_PROD",
  },
  b2cUrls: {
    signin:
      "https://sbvexpertsystemprodb2c.b2clogin.com/sbvexpertsystemprodb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_SIGNIN_PROD&client_id=e0211b05-d0ad-44e5-af96-a1956609a125&nonce=defaultNonce&scope=openid&response_type=id_token&prompt=login",
    signup:
      "https://sbvexpertsystemprodb2c.b2clogin.com/sbvexpertsystemprodb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNUP_PROD&client_id=e0211b05-d0ad-44e5-af96-a1956609a125&nonce=defaultNonce&scope=openid&response_type=id_token&prompt=login",
    resetPassword:
      "https://sbvexpertsystemprodb2c.b2clogin.com/sbvexpertsystemprodb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_RESETPASSWORD_PROD&client_id=e0211b05-d0ad-44e5-af96-a1956609a125&nonce=defaultNonce&scope=openid&response_type=id_token&prompt=login",
  },
  buyingScaitCreditsUrl: "https://app.scait.ch/sbv/login?token=",
  paymentHistoryUrl: "https://app.scait.ch/sbv/login?token=",

  hidePaymentMethodSelection: true,

  // When true, hides the super-admin associations tab and the association
  // column in the employee tables.
  hideAssociations: true,
});
